import fetch from 'isomorphic-fetch';

let ENDPOINT_URL = process.env.VUE_APP_SERVICES_DELETE;
async function deleteService(id) {
  const bodyParams = {
    _id: id,
    token: localStorage.getItem('token'),
  };

  let body = JSON.stringify(bodyParams);

  return await fetch(ENDPOINT_URL, {
    method: 'delete',
    headers: {
      'Content-Type': 'application/json',
    },
    body,
  }).then((item) => item.json());
}
export { deleteService };
